export interface Point {
  x: number;
  y: number;
}

export function normalizeMovement(x: number, y: number): Point {
  const magnitude = Math.hypot(x, y);
  return magnitude > 1 ? { x: x / magnitude, y: y / magnitude } : { x, y };
}

export function interpolateAngle(
  from: number,
  to: number,
  fraction: number,
): number {
  const difference = Math.atan2(Math.sin(to - from), Math.cos(to - from));
  return from + difference * fraction;
}

export function screenToWorld(
  point: Point,
  camera: Point,
  width: number,
  height: number,
  zoom: number,
): Point {
  return {
    x: camera.x + (point.x - width / 2) / zoom,
    y: camera.y + (point.y - height / 2) / zoom,
  };
}

export function worldToScreen(
  point: Point,
  camera: Point,
  width: number,
  height: number,
  zoom: number,
): Point {
  return {
    x: width / 2 + (point.x - camera.x) * zoom,
    y: height / 2 + (point.y - camera.y) * zoom,
  };
}
